// extracted by mini-css-extract-plugin
export var heroImage = "_kk-1";
export var modal = "_kk-0";